const BACKEND_URL = 'https://dev-api.stronx.app/api';

export const environment = {
  name: 'development',
  production: false,
  apiBaseUrl: `${BACKEND_URL}`,
};
